import { useFormikContext } from "formik";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { EmpowerScheduleForm } from "../EmpowerMeTaskModal";
import {
  RRuleEndAfterCountFieldName,
  RRuleEndConditionFieldName,
  RRuleEndNever,
  RRuleEndOnDateFieldName,
  RRuleIntervalFieldName,
  ScheduleDateFieldName,
  ScheduleTimeFieldName,
} from "./EmpowerMeFormFieldConstants";
import { RecurrenceSelection } from "./EmpowerMeRecurrenceSelection";
import styles from "./EmpowerMeScheduling.module.scss";
import DateTime from "react-datetime";
import {DateFormat} from "../../../helper/constants"
import moment from 'moment';
import { EmpowerTask } from "../../../interfaces/models/EmpowerTask";
import { EmpowerMeBundle } from "../../../interfaces/models/EmpowerMeBundle";
import { Table } from "reactstrap";
import { useEffect, useRef } from "react";
import FormError from "../../../components/Shared/Forms/FormError";


interface ScheduleSelectionProps {
  recurrenceEnabled: boolean;
  enableRecurrence: (enableRecurrence: boolean) => void;
  currentSelection: EmpowerTask;
  currentSelectionBundle: EmpowerMeBundle;
  setBundleTimes : (time : string[]) => void;
  bundleTimes  : string[];
  bundleDate : string;
  setBundleDate : (date : string) => void;
  validateDate : (date: string, time : string, index : number | null) => string;
}

export default function EmpowerScheduleSelection({
  recurrenceEnabled,
  enableRecurrence,
  currentSelection,
  currentSelectionBundle,
  bundleTimes, 
  setBundleTimes,
  bundleDate, 
  setBundleDate,
  validateDate,
}: ScheduleSelectionProps) {
  const formikCtx = useFormikContext<EmpowerScheduleForm>();

  const OnDateChanged = (date : string) => {
    setBundleDate(date);
  }

  const OnTimeChanged = (index : number, time : string) => {
    const copyBundleTimes = [...bundleTimes];

    copyBundleTimes[index] = time;
    setBundleTimes(copyBundleTimes);
  }

  const OnValidateDate = (index : number) => {

    const result = validateDate(bundleDate, bundleTimes[index], index);
    console.log(result);
    if(result !== "" && result !== null) {
      return <FormError><small>{result}</small></FormError>
    }

    return <></>
  }

  const OnValidateDateSingle = () => {
    const result = validateDate(formikCtx.values.date, formikCtx.values.time, null);
    if(result !== "" && result !== null) {
      return <FormError><small>{result}</small></FormError>
    }

    return <></>
  }

  const initialDate = useRef<Date>(new Date());
  const formRef = useRef(formikCtx);

  useEffect(() => {
    if(currentSelection === null){
      const updatedDate = moment().add(1,'day').toDate();
      initialDate.current = updatedDate;
      const reformated = moment(updatedDate).format("yyyy-MM-DD");
      formRef.current.setFieldValue(ScheduleDateFieldName,reformated)   
    } 
  }, [currentSelection])

  return (
    <div className={styles.schedulingForm}>
      {/* Date and Time Selector */}
      {
        currentSelection !== null ?
        <div className={`${styles.dateTimeFields} form-group`}>
          <div className={styles.recurrenceRepeatRule}>
            <label>Select Date:</label>
            <div className="w-100">
              <DateTime 
                className="w-100" 
                onChange={(date) => {
                    const reformated = moment(date).format("yyyy-MM-DD");
                    formikCtx.setFieldValue(ScheduleDateFieldName,reformated)   
                }} 
                dateFormat={DateFormat} 
                timeFormat={false}  
                initialValue={initialDate.current}
                inputProps={{readOnly : true ,className:"form-control bg-white"}}
              />
              <p className={styles.fieldError}>
                {formikCtx.getFieldMeta(ScheduleDateFieldName).touched &&
                  formikCtx.getFieldMeta(ScheduleDateFieldName).error}
              </p>
            </div>
          </div>
          <div className={styles.recurrenceRepeatRule}>
            <label>Time:</label>
            <div className="w-100">
              {/* <Field
                className="form-control"
                name={ScheduleTimeFieldName}
                type="time"
                validate={validateTime}
              /> */}
              <DateTime 
                className="w-100" 
                onChange={(date) => {
                  const reformated = moment(date).format("HH:mm");
                  formikCtx.setFieldValue(ScheduleTimeFieldName,reformated)   
                }} 
                dateFormat={false} 
                timeFormat={true}  
                initialValue={initialDate.current}
                inputProps={{readOnly : false ,className:"form-control bg-white"}}
              />
              <p className={styles.fieldError}>
                {formikCtx.getFieldMeta(ScheduleTimeFieldName).touched &&
                  formikCtx.getFieldMeta(ScheduleTimeFieldName).error}
              </p>
              {
                OnValidateDateSingle()
              }
            </div>
          </div>
        </div>
        :
        <div>
          <h4>Bundle: {currentSelectionBundle.name}</h4>
          {formikCtx.getFieldMeta(ScheduleTimeFieldName).touched &&
                  formikCtx.getFieldMeta(ScheduleTimeFieldName).error}
          <Table bordered size="sm" >
            <colgroup>
              <col style={{maxWidth:"40%"}}></col>
              <col style={{maxWidth:"30%"}}></col>
              <col style={{maxWidth:"30%"}}></col>
            </colgroup>
            <thead>
              <tr>
                <th >Name </th>
                <th>Date</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {
                currentSelectionBundle.tasks.map((task, index) => {

                  const presetDate = moment(bundleDate + " " + bundleTimes[index],"YYYY-MM-DD HH:mm")
                  return (
                    <tr key={index}>
                      <td >
                        <div className="table-description-details" >
                          {task.empower_me_task_details.name}
                        </div>
                      </td>
                      {
                        index === 0 &&
                        <td rowSpan={3} className="align-middle" >
                          <div  className="">
                            <DateTime 
                              className="w-100" 
                              onChange={(date) => {
                                  const reformated = moment(date).format("yyyy-MM-DD");
                                  OnDateChanged(reformated);
                              }} 
                              dateFormat={DateFormat} 
                              timeFormat={false}  
                              initialValue={presetDate}
                              inputProps={{readOnly : true ,className:"form-control bg-white"}}
                            />
                          </div>
                        </td>
                      }
                      <td>
                      <DateTime 
                        className="w-100" 
                        onChange={(date) => {
                          const reformated = moment(date).format("HH:mm");
                          OnTimeChanged(index,reformated);
                        }} 
                        dateFormat={false} 
                        timeFormat={true}  
                        initialValue={presetDate}
                        inputProps={{readOnly : true ,className:"form-control bg-white"}}
                      />
                      {
                        OnValidateDate(index)
                      }
                      </td>
                    </tr>
                  )
                })
              }     
            </tbody>
          </Table>
          
        </div>
      }
      

      {/* Recurrence prompt */}
      <div className={`${styles.recurrencePrompt} mb-5`}>
        <p>Would you like your task to repeat?</p>
        <ToggleButtonGroup
          type="radio"
          name="enableRecurrence"
          defaultValue={recurrenceEnabled ? 1 : 0}
          className={styles.recurrenceButtonsGroup}
        >
          <ToggleButton
            id="yes"
            type="radio"
            onClick={() => {
              enableRecurrence(true);
            }}
            value={0}
            checked={recurrenceEnabled}
            className={`${styles.recurrenceButton} ${
              recurrenceEnabled ? "btn-primary" : "btn-secondary"
            }`}
          >
            Yes
          </ToggleButton>
          <ToggleButton
            id="no"
            type="radio"
            onClick={() => {
              enableRecurrence(false);

              // Clear existing formik errors for disabled fields
              formikCtx.setFieldError(RRuleIntervalFieldName, undefined);
              formikCtx.setFieldError(RRuleEndOnDateFieldName, undefined);
              formikCtx.setFieldError(RRuleEndAfterCountFieldName, undefined);
            }}
            value={1}
            checked={!recurrenceEnabled}
            className={`${styles.recurrenceButton} ${
              !recurrenceEnabled ? "btn-primary" : "btn-secondary"
            }`}
          >
            No
          </ToggleButton>
        </ToggleButtonGroup>
      </div>

      <RecurrenceSelection
        recurrenceEnabled={recurrenceEnabled}
        endConditionFieldName={RRuleEndConditionFieldName}
        endNever={RRuleEndNever}
        endOnDateFieldName={RRuleEndOnDateFieldName}
        endAfterCountFieldName={RRuleEndAfterCountFieldName}
      />
    </div>
  );
}
